import {useContext} from 'react';
import {StateContext} from '../utils/stateContext.client';

export const useSiteContext = () => {
  const context = useContext(StateContext);
  if (context === undefined) {
    throw new Error(`useSiteContext must be used within a SiteProvider`);
  }
  return context;
};
